import type { TCMSContent } from '@/types/cms';
import type { TOptional } from '@/types/common';

import { env } from '@/environment';

const getScriptUrl = (content: string): TOptional<string> => {
  // eslint-disable-next-line no-useless-escape
  const attr = /data-script-assets="([\w-\/\.\:\?\=]+)"/.exec(content);
  return attr?.[1];
};

const prepareUrl = (url: string, params?: Record<string, unknown>): URL => {
  const result = new URL(url);
  if (params) Object.entries(params).forEach(([name, value]) => result.searchParams.append(name, `${value}`));
  return result;
};

export const getContent = async (url: string, params?: Record<string, unknown>): Promise<TCMSContent> => {
  const request = await fetch(prepareUrl(url, params), { next: { revalidate: +env.NEXT_CACHE_TIME } });
  const content = await request.text();
  const scriptUrl = getScriptUrl(content);
  return { content, ...(scriptUrl && { scriptUrl }) };
};

export type THeaderFooterArgs = {
  version?: number;
};

export type THeaderArgs = THeaderFooterArgs & {
  withBookButton?: boolean;
};

export const getHeaderContent = async ({ version, withBookButton }: THeaderArgs = {} as THeaderArgs) =>
  getContent(`${env.CMS_COMPONENT_BASE_URL}/globalNav/${version || 0}`, {
    headerForBooking: !withBookButton,
  });

export const getFooterContent = async ({ version }: THeaderFooterArgs = {} as THeaderFooterArgs) =>
  getContent(`${env.CMS_COMPONENT_BASE_URL}/footer/${version || 0}`);
